const DROPPABLE_ATTRIBUTE = "droppable";
export { DROPPABLE_ATTRIBUTE };
